import { render, staticRenderFns } from "./DashboardRecebimentoFuturo.vue?vue&type=template&id=17ccc1cc&scoped=true"
import script from "./DashboardRecebimentoFuturo.vue?vue&type=script&lang=ts"
export * from "./DashboardRecebimentoFuturo.vue?vue&type=script&lang=ts"
import style0 from "./DashboardRecebimentoFuturo.vue?vue&type=style&index=0&id=17ccc1cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ccc1cc",
  null
  
)

export default component.exports